import { Map } from 'immutable'

export function getLocation (state) {
  return state.getIn(['routing', 'locationBeforeTransitions'], new Map())
}

export function getQuery (state) {
  return getLocation(state).get('query')
}
